export const HOME_VIEWS = {
  FRANCHISE_MARKETING: "franchise-marketing",
  DEFAULT: "default",
};

export function isFranchiseMarketingProfile(userDetail) {
  return !!userDetail?.UsuarioPerfis?.some((perfil) => {
    const nome = perfil.NomePerfil || "";
    return nome.startsWith("FRANQUEADO_") || nome.startsWith("FRANQUIAS_");
  });
}

export function getHomeView(userDetail) {
  if (isFranchiseMarketingProfile(userDetail)) {
    return HOME_VIEWS.FRANCHISE_MARKETING;
  }
  return HOME_VIEWS.DEFAULT;
}
